import {
	Multiselect,
} from '@ascension/web';
import React from 'react';
import { SortingComponentProps } from './SortingComponentProps';
import { useFilterState } from '../Filters/FiltersContext/FiltersContext';
import { DropdownOption } from '@definitions/DropdownOption';
import { Box, alpha, makeStyles } from '@material-ui/core';
import { useCommonStyles } from '@utilities/hooks/useCommonStyles/useCommonStyles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => {
	return {
		sortingDropdown: {
			'minWidth': 120,
			'minHeight': '49px',
			'border': '1px solid',
			'borderRadius': theme.spacing(.5),
			'borderColor': alpha(theme.palette.common.black, .6),
			'& > div > div > div:nth-of-type(2)': {
				marginTop: theme.spacing(.2),
			},
			'& span:first-of-type': {
				color: theme.palette.grey[600],
			},
		},
	};
});

export default function SortingComponent ({ options, ...rest }: SortingComponentProps) {
	const classes = useStyles();
	const { hideMultiselectSearchFilter } = useCommonStyles();
	const { sortModel, updateFilterPropsAndResetFilterToggle } = useFilterState();

	const option = options.filter( item => item.value == sortModel);

	const handleChange = (newValue: DropdownOption[]) => {
		updateFilterPropsAndResetFilterToggle({ sortModel: newValue[0].value });
	};

	return (
		<Box data-field="SORT_BY" className={classNames(classes.sortingDropdown, hideMultiselectSearchFilter)}>
			<Multiselect single value={option} onChange={handleChange} label="Sort by" options={options} filterable {...rest}/>
		</Box>
	);
}
